// What a refused Sign says (smoke test, 21 Oct): every path that stops a sign tells the clinician why, never a dead click.
export const SIGN_BLOCKED = {
  notLoaded: 'The note can’t be signed yet: the encounter hasn’t finished loading. Reload the page and sign again.',
  noPractitioner: 'Your sign-in has no practitioner profile, so the note can’t be signed. Sign out and in again.',
  followUpSaving: 'Saving follow-up — one moment…',
  followUpFailed: 'The follow-up in Wrap-Up didn’t save — adjust it there to retry, then sign.',
  assessmentSaving: 'Saving assessment — one moment…',
  heldWriteFailed: 'A change didn’t save, so the note was not signed. Fix the failed save, then sign again.',
} as const;
